import { Layout, Button, Image, Typography } from 'antd'
import { LanguageSwitch } from '../components/'
import { useAuth } from '../context/AuthProvider'
import { useCustomisation } from '../context/CustomisationProvider'

export const Header = () => {
  const { user, token, onLogout } = useAuth()
  const { theme, loading } = useCustomisation()
  return (
    <Layout.Header>
      <a href="https://openpublishing.com" target="_blank" rel="noreferrer">
        <img
          className="logo"
          style={{ height: theme.logoHeight }}
          src={loading ? '' : theme.logo}
          alt="logo"
        />
      </a>
      {/* TODO: remove or style properly this button */}
      {token && (
        <Button
          type="link"
          onClick={onLogout}
          style={{ margin: '20px', opacity: 0 }}
        >
          Sign Out
        </Button>
      )}
      {token && (
        <a className="user-name" href="" target="_blank">
          <Typography.Paragraph>
            {user && <Typography.Text role="user">{user}</Typography.Text>}
            <Image
              src="images/common/person-fill.svg"
              preview={false}
              alt="person icon"
            />
          </Typography.Paragraph>
        </a>
      )}
      <LanguageSwitch />
    </Layout.Header>
  )
}
